import { fetcher } from "helpers/fetcher";

import { TAddAssignmentAllReq, TAddAssignmentAllRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const addAssignmentAll = async (payload: TAddAssignmentAllReq) => {
  return await fetcher<TAddAssignmentAllRes, TAddAssignmentAllReq["data"]>(
    ENDPOINT.BU.ADD_ASSIGNMENT_ALL,
    {
      data: payload.data,
      headers: {
        [API_HEADER.BU_ID]: payload.buId,
        [API_HEADER.VERSION]: ENDPOINT.BU.ADD_ASSIGNMENT_ALL.version,
      },
    }
  );
};

export const mutationAddAssignmentAll = async (
  payload: TAddAssignmentAllReq
) => {
  return (await addAssignmentAll(payload)).data.message;
};

mutationAddAssignmentAll._key = (payload: TAddAssignmentAllReq) => [
  ENDPOINT.BU.ADD_ASSIGNMENT_ALL.url,
  payload,
];
